import { j as r } from "../../../jsx-runtime-B6kdoens.js";
import { useContext as m } from "react";
import { c as n } from "../../../index-CROKJrb5.js";
import { c as p, f } from "../../../create-component-CBAeEoQ6.js";
import { Typography as x } from "../../Typography/index.js";
import { C as l } from "../../../CardContext-B6h__heb.js";
const d = n({
  base: "cur-flex cur-flex-wrap cur-items-baseline cur-gap-2",
  variants: {
    surface: {
      transparent: "cur-px-2",
      white: "cur-px-1"
    }
  }
}), v = p(
  "CardTags",
  f(
    ({ as: a, children: e, className: o, title: s, ...t }, c) => {
      const u = a || "div", { surface: i } = m(l);
      return /* @__PURE__ */ r.jsxs(
        u,
        {
          ref: c,
          className: d({ surface: i, className: o }),
          ...t,
          children: [
            s && /* @__PURE__ */ r.jsx(x, { size: "meta", weight: "bold", children: s }),
            /* @__PURE__ */ r.jsx("div", { className: "cur-shrink-1 cur-flex cur-max-w-full cur-flex-shrink-0 cur-basis-auto cur-flex-wrap cur-gap-1", children: e })
          ]
        }
      );
    }
  )
);
export {
  v as CardTags
};
//# sourceMappingURL=index.js.map
